module.exports = __webpack_public_path__ + "static/Slack-50ca277f9aae197c39e8fd2a59c47080.png";